import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from "axios";
import {useSelector} from "react-redux";

export const OpayoDecline = () => {
    const navigate = useNavigate();
    const [vendorTxCode, setVendorTxCode] = useState(null);
    const [searchParams] = useSearchParams();
    const apiURL = useSelector(state => state.mopriSettings.mopriAPIURL);

    useEffect(() => {
        const code = searchParams.get('vendorTxCode');
        if (code) {
            setVendorTxCode(code);
            console.log("Vendor Transaction Code:", code);
            declineOpayoTransaction(code)
        }
    }, [searchParams]);

    const declineOpayoTransaction = async (tid) => {
        const response = await axios.post(`${apiURL}/api/gateway/decline-opayo-payment`, {
            tid: tid,
        })
    }

    const goBack = () => {
        navigate('/topup');
    };

    return (
        <div className="grid justify-content-center align-items-center bg-gray-100">
            <div className="col-12 md:col-6 lg:col-6">
                <Card
                    className="shadow-2 surface-card"
                    style={{ marginTop: '0', paddingTop: '2rem' }}
                    title={
                        <div className="flex align-items-center" style={{color: 'red'}}>
                            <FontAwesomeIcon icon={faTimesCircle} className="mr-2 text-red-500 text-2xl" />
                            <span className="text-xl font-semibold">Payment Declined</span>
                        </div>
                    }
                >
                    <div className="mb-4">
                        <img
                            src="/img/opayo.png"
                            alt={"Opayo"}
                            style={{
                                height: '60px',
                                width: 'auto',
                            }}
                        />
                        <p className="mt-2 text-lg text-gray-700">
                            We're sorry, but your payment was declined or encountered an error.
                        </p>
                        <p className="mt-2 text-lg text-gray-700">
                            Your account balance has not been updated.
                        </p>
                    </div>
                    <div className="mb-4 text-gray-600">
                        <p>Please double-check your payment details and try again.</p>
                        <p>If the issue persists, you may want to contact your bank or try a different payment method.</p>
                    </div>
                    <div className="flex justify-content-end">
                        <Button label="Try Again" icon="pi pi-refresh" className="p-button-warning mr-2" onClick={goBack} />
                    </div>
                </Card>
            </div>
        </div>
    );
};